module.exports = __webpack_public_path__ + "static/media/check-solid-green-v2.fa30046f.svg";